import { motion } from "framer-motion";
import React from "react";
import { Location } from "../../domain/models/locations/Location";
import { ReactComponent as CloseIcon } from "../../icons/xmark.svg";
import PlaceEventBox from "./PlaceEventBox";

type PlaceEventModalProps = {
  open: boolean;
  onClose: () => void;
  pos: Location;
  style?: React.CSSProperties;

};

const PlaceEventModal: React.FC<PlaceEventModalProps> = ({
  open,
  onClose,
  pos,
  style,
}) => {
  if (!open) return null;


  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-[9999999] flex items-center justify-center bg-black bg-opacity-50"
    >
      <div
        className="fixed left-0 right-0 z-50"
        style={{
          ...style,
          position: 'fixed',
          pointerEvents: 'none',
          bottom: style?.bottom || '84.5px', // props로 받은 bottom 값 사용
          // top: undefined, // top 값은 반드시 제거!
          display: 'flex',
          justifyContent: 'center'
          // alignItems: 'flex-end', // 필요시 추가
        }}
      >
        <div
          className="relative bg-pure-white dark:bg-background-dark rounded-[16px] shadow-lg p-0 w-[327px] mx-auto "
          style={{
            pointerEvents: 'auto' // ★ 추가!
          }}
        >
          {/* 닫기 버튼 */}
          <button
            onClick={onClose}
            className="
              absolute
              w-[34px] h-[34px]
              -top-[17px] -right-[17px]
              bg-pure-black
              rounded-full
              flex items-center justify-center
              border-none
              z-10
              cursor-pointer
              rotate-[-0.73deg]
            "
          >
            {/* span 태그 없애고 아이콘만 남김 */}
            <CloseIcon className="fill-pure-white w-[18px] h-[18px]" />{' '}
            {/* 아이콘 크기랑 색상 유지! */}
          </button>
          <div className="w-full h-full pt-[14px] pr-[16px] pb-[16px] pl-[16px]">
            <PlaceEventBox pos={pos} />
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default PlaceEventModal;



